import httpAuth from '@/services/httpAuth'

import { serialize } from '@/services/object'

export async function list (filtros, all = false) {
  return httpAuth.get(`/admin/alertas-notificacoes?${serialize({ ...filtros, all })}`, {
    tela: 'alertas-notificacoes'
  })
}

export async function listFiltro (url, dados, all) {
  if (dados.tipo === 'pesquisa') {
    return httpAuth.get(`${url}?${dados.query}&${all}`)
  } else {
    return httpAuth.get(`${url}?${dados.query}&${all}`)
  }
}

export async function add (funcionalidade, dados) {
  return httpAuth.post('/admin/alertas-notificacoes', dados, { funcionalidade: funcionalidade })
}

export async function edit (funcionalidade, id, dados) {
  return httpAuth.put(`/admin/alertas-notificacoes/${id}`, dados, { funcionalidade: funcionalidade })
}

export async function del (funcionalidade, id) {
  return httpAuth.delete(`/admin/alertas-notificacoes/${id}`, { funcionalidade: funcionalidade })
}
